module.exports = __webpack_public_path__ + "static/media/machine_success.8550915a.svg";